import { useEffect, useState } from "react";
import { AuthTokenRetrieve, LoginButton } from "./AuthTokenRetrieve";

const PrivateSectionGate = (props) => {
  const { title, description, children, className = "" } = props;
  const [shouldShow, setShouldShow] = useState(false);
  const { shouldShow: hasPrivateAccess, isLoading } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(hasPrivateAccess);
  }, [hasPrivateAccess]);

  if (isLoading) {
    return (
      <div className={`searchBarDiv formViewWrapper PrivateAccessGate ${className}`.trim()}>
        <h2>{title}</h2>
        <p>Checking access...</p>
      </div>
    );
  }

  if (!shouldShow) {
    return (
      <div className={`searchBarDiv formViewWrapper PrivateAccessGate ${className}`.trim()}>
        <h2>{title}</h2>
        <p>{description}</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  return children;
};

export default PrivateSectionGate;
